import React from 'react';
import { GetTrackProps, TrackItem } from 'react-compound-slider';

import { RangeInputTrack } from '../styles';

export interface RangeInputTracksProps {
  tracks: TrackItem[];
  getTrackProps: GetTrackProps;
}

export const RangeInputTracks = ({ tracks, getTrackProps }: RangeInputTracksProps) => (
  <>
    {tracks.map(({ id, source, target }) => (
      <RangeInputTrack
        key={id}
        sourcePercent={source.percent}
        targetPercent={target.percent}
        {...getTrackProps()}
      />
    ))}
  </>
);
